import { ApplicationVariableIcon } from './ApplicationVariableIcon';

/**
 * author: Michael Irigoyen
 * id A42EE2E1-D139-426F-9B59-C21E8C185DA7
 * name application-variable
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-variable.svg
 * tags
 * - Developer / Languages 
 */
export const IframeVariableIcon = ApplicationVariableIcon;
export default IframeVariableIcon